export default __webpack_public_path__ + "static/media/product13.2cd0047e.jpg";